export const GROUPS = {
  COMPANY_ADMIN: 'Company admin',
  COMPANY_EMPLOYEE: 'Company employee',
};

export const ROLES = {
  ADMIN: 'org:admin',
  EMPLOYEE: 'org:employee',
};
